module.exports = __webpack_public_path__ + "files/5e95a3c798346a757e39b1d8c66e2e47.png";